import { render, staticRenderFns } from "./UserEditDetailsTab.vue?vue&type=template&id=975d9dc4"
import script from "./UserEditDetailsTab.vue?vue&type=script&lang=ts"
export * from "./UserEditDetailsTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports